// import Footer from "../standartComponent/footer/footer";
// import Header from "../standartComponent/header/header";
// import CatalogProductComponent from "../standartComponent/productComponent/catalogProductComponent";
// import Filter from "./filter";
// import FirstBlockCat from "./firstBlockCat";
// import YouLikeIt from "./youLikeIt";
// import "../standartComponent/productComponent/productStyle.css";
// import DiscountAndAction from "./discountAndAction";
// import ViewProductCatalog from "./viewProductCatalog";
// import Card from "../standartComponent/card/card";
// import ListButtonCount from "./listButtonCount";
// import { useState } from "react";
// import { useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import FirstBlockMan from "./firstBlockMan";
// import ManuscriptProductComponent from "../standartComponent/productComponent/manuscriptProductComponent";
// import css from "./catalog.module.css";

// export default function CatalogMan({
//   setVisitedProducts,
//   visitedProducts,
//   productsAll,
// }) {
//   const productsFromStore = useSelector((state) => state.manuscript.items);
//   const filters = useSelector((state) => state.manuscriptFilter);

//   // ✅ FIX: якщо в Redux пусто — рендеримо з props productsAll
//   const products =
//     Array.isArray(productsFromStore) && productsFromStore.length
//       ? productsFromStore
//       : Array.isArray(productsAll)
//         ? productsAll
//         : [];

//   const [currentPage, setCurrentPage] = useState(1);
//   const productsPerPage = 10;

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   console.log("productsFromStore", productsFromStore);
//   console.log("productsAll", productsAll);
//   console.log("products (render source)", products);

//   const startIndex = (currentPage - 1) * productsPerPage;
//   const endIndex = startIndex + productsPerPage;
//   const currentProducts = products.slice(startIndex, endIndex);

//   const numberOfPages = Math.ceil(products.length / productsPerPage);
//   const maxDisplayedPages = 5;
//   const firstDisplayedPages = Math.max(
//     currentPage - Math.floor(maxDisplayedPages / 2),
//     1,
//   );
//   const lastDisplayedPages = Math.min(
//     firstDisplayedPages + maxDisplayedPages - 1,
//     numberOfPages,
//   );

//   const pageNumbers = [];
//   for (let i = firstDisplayedPages; i <= lastDisplayedPages; i++) {
//     pageNumbers.push(i);
//   }
//   console.log("currentProducts", currentProducts);

//   return (
//     <>
//       {/*
//         <Filter filters={filters}/>
//         */}
//       <FirstBlockMan />
//       <div className={css.manTextWrapUp}>
//         <div className={css.manTextWrapUpSmall}>
//           <p className={css.manTextWrapUpP}>
//             <strong>Читати важливо.</strong> <br />
//             Від того, що ти читаєш, залежить твоє життя. Перед Вами рукописи,
//             подані авторами на розгляд до видавництва. Допоможіть обрати
//             найкращий серед них. Для цього почніть їх читати. Якщо Вам
//             сподобається, Ви можете замовити доступ до повного тексту, після
//             прочитання якого можна залишити відгук і побажання автору.
//             <br />
//             <br /> Любі читачі, зараз Вас не так багато серед спільноти. Ваша
//             цінність від того росте. Ілон Маск згадує, що в дитинстві читав усе,
//             до чого могла дотягнутись рука. Ймовірність досягти його рівня
//             більша у дітей, які читають, вища, ніж в інших. Тому ми вас цінуємо
//             і працюємо на вас. Та робити для Вас без Вас — неправильно. Тому
//             долучайтесь до книготворення!
//             <br />
//             <br /> Ми шукаємо рукопис, який прославив би Україну на цілий світ.
//             Рукопис, який був би цінним і через десятки років. Для нас важливо,
//             щоб він читався на одному подиху, але цього не достатньо. Ми
//             дивимося на те, які зерна сіє текст у дитячі серця, та чим ці зерна
//             проростають. Наше завдання — створити НЕОБХІДНІ ДІТЯМ КНИЖКИ. Наше
//             прагнення — зробити їх витворами мистецтва.
//           </p>
//         </div>
//       </div>

//       {currentProducts.map((el) => {
//         return (
//           <ManuscriptProductComponent
//             visitedProducts={visitedProducts}
//             setVisitedProducts={setVisitedProducts}
//             el={el}
//             key={el?.uid} // ✅ краще ніж index
//           />
//         );
//       })}

//       <ListButtonCount
//         pageNumbers={pageNumbers}
//         handlePageClick={handlePageClick}
//       />

//       {/*<YouLikeIt/>*/}
//       {/* <DiscountAndAction /> */}
//       <ViewProductCatalog products={productsAll} />
//       <Footer />
//     </>
//   );
// }
import Footer from "../standartComponent/footer/footer";
import "../standartComponent/productComponent/productStyle.css";
import ViewProductCatalog from "./viewProductCatalog";
import ListButtonCount from "./listButtonCount";
import { useMemo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { collection, getDocs } from "firebase/firestore";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import FirstBlockMan from "./firstBlockMan";
import ManuscriptProductComponent from "../standartComponent/productComponent/manuscriptProductComponent";
import { db } from "../../firebase";
import {
  filterMastersBySearch,
  getActiveMaster,
  getAssignedManuscripts,
  getEntityId,
  getMastersWithManuscripts,
} from "../../services/manuscriptMasterService";
import css from "./catalog.module.css";

export default function CatalogMan({
  setVisitedProducts,
  visitedProducts,
  productsAll,
}) {
  const productsFromStore = useSelector((state) => state.manuscript.items);

  const products = useMemo(
    () =>
      Array.isArray(productsFromStore) && productsFromStore.length
        ? productsFromStore
        : Array.isArray(productsAll)
          ? productsAll
          : [],
    [productsAll, productsFromStore],
  );

  const [masters, setMasters] = useState([]);
  const [selectedMasterId, setSelectedMasterId] = useState("");
  const [masterSearch, setMasterSearch] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [currentManuscriptIndex, setCurrentManuscriptIndex] = useState(0);

  const productsPerPage = 10;

  useEffect(() => {
    let isMounted = true;

    const fetchMasters = async () => {
      try {
        const snapshot = await getDocs(collection(db, "author"));
        const loadedMasters = snapshot.docs.map((docItem) => ({
          id: docItem.id,
          ...docItem.data(),
        }));

        if (isMounted) {
          setMasters(loadedMasters);
        }
      } catch (error) {
        console.error("Не вдалося завантажити майстрів рукописів:", error);
      }
    };

    fetchMasters();

    return () => {
      isMounted = false;
    };
  }, []);

  const mastersWithManuscripts = useMemo(
    () => getMastersWithManuscripts(masters, products),
    [masters, products],
  );

  const visibleMasters = useMemo(
    () => filterMastersBySearch(mastersWithManuscripts, masterSearch),
    [mastersWithManuscripts, masterSearch],
  );

  const masterCandidates = masterSearch.trim()
    ? visibleMasters
    : mastersWithManuscripts;

  const selectedMaster = useMemo(
    () => getActiveMaster(masterCandidates, selectedMasterId),
    [masterCandidates, selectedMasterId],
  );

  const activeMasterId = getEntityId(selectedMaster);

  const masterProducts = useMemo(
    () =>
      selectedMaster
        ? getAssignedManuscripts(selectedMaster, products)
        : mastersWithManuscripts.length > 0
          ? []
          : products,
    [mastersWithManuscripts.length, products, selectedMaster],
  );

  const noMasterSearchResults =
    Boolean(masterSearch.trim()) && visibleMasters.length === 0;

  const yearOptions = useMemo(() => {
    const yearsSet = new Set();

    masterProducts.forEach((product) => {
      const yearGroup = product?.yearGroup;

      if (Array.isArray(yearGroup)) {
        yearGroup.forEach((year) => {
          if (year !== undefined && year !== null && year !== "") {
            yearsSet.add(String(year));
          }
        });
      } else if (
        yearGroup !== undefined &&
        yearGroup !== null &&
        yearGroup !== ""
      ) {
        yearsSet.add(String(yearGroup));
      }
    });

    return Array.from(yearsSet).sort((a, b) => Number(a) - Number(b));
  }, [masterProducts]);

  const filteredProducts = useMemo(() => {
    if (!selectedYear) return masterProducts;

    return masterProducts.filter((product) => {
      const yearGroup = product?.yearGroup;

      if (Array.isArray(yearGroup)) {
        return yearGroup.map(String).includes(String(selectedYear));
      }

      return String(yearGroup || "") === String(selectedYear);
    });
  }, [masterProducts, selectedYear]);

  useEffect(() => {
    setCurrentPage(1);
    setCurrentManuscriptIndex(0);
  }, [activeMasterId, selectedYear]);

  useEffect(() => {
    if (currentManuscriptIndex < filteredProducts.length) return;
    setCurrentManuscriptIndex(0);
  }, [currentManuscriptIndex, filteredProducts.length]);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleYearChange = (year) => {
    setSelectedYear(year);
  };

  const handleMasterSelect = (masterId) => {
    setSelectedMasterId(masterId);
    setSelectedYear("");
  };

  const handlePreviousManuscript = () => {
    setCurrentManuscriptIndex((current) =>
      current === 0 ? filteredProducts.length - 1 : current - 1,
    );
  };

  const handleNextManuscript = () => {
    setCurrentManuscriptIndex((current) =>
      current + 1 >= filteredProducts.length ? 0 : current + 1,
    );
  };

  const startIndex = (currentPage - 1) * productsPerPage;
  const endIndex = startIndex + productsPerPage;
  const currentProducts = selectedMaster
    ? filteredProducts.slice(
        currentManuscriptIndex,
        currentManuscriptIndex + 1,
      )
    : filteredProducts.slice(startIndex, endIndex);

  const numberOfPages = Math.ceil(filteredProducts.length / productsPerPage);
  const maxDisplayedPages = 5;
  const firstDisplayedPages = Math.max(
    currentPage - Math.floor(maxDisplayedPages / 2),
    1,
  );
  const lastDisplayedPages = Math.min(
    firstDisplayedPages + maxDisplayedPages - 1,
    numberOfPages,
  );
  const pageNumbers = [];

  for (let i = firstDisplayedPages; i <= lastDisplayedPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <>
      <FirstBlockMan
        yearOptions={yearOptions}
        selectedYear={selectedYear}
        onYearChange={handleYearChange}
        masters={visibleMasters}
        hasConfiguredMasters={mastersWithManuscripts.length > 0}
        selectedMasterId={activeMasterId}
        onMasterSelect={handleMasterSelect}
        masterSearch={masterSearch}
        onMasterSearchChange={setMasterSearch}
      />

      <div className={css.manTextWrapUp}>
        <div className={css.manTextWrapUpSmall}>
          <p className={css.manTextWrapUpP}>
            <strong>Читати важливо.</strong> <br />
            Від того, що ти читаєш, залежить твоє життя. Перед Вами рукописи,
            подані авторами на розгляд до видавництва. Допоможіть обрати
            найкращий серед них. Для цього почніть їх читати. Якщо Вам
            сподобається, Ви можете замовити доступ до повного тексту, після
            прочитання якого можна залишити відгук і побажання автору.
            <br />
            <br />
            Любі читачі, зараз Вас не так багато серед спільноти. Ваша цінність
            від того росте. Ілон Маск згадує, що в дитинстві читав усе, до чого
            могла дотягнутись рука. Ймовірність досягти його рівня більша у
            дітей, які читають, вища, ніж в інших. Тому ми вас цінуємо і
            працюємо на вас. Та робити для Вас без Вас — неправильно. Тому
            долучайтесь до книготворення!
            <br />
            <br />
            Ми шукаємо рукопис, який прославив би Україну на цілий світ.
            Рукопис, який був би цінним і через десятки років. Для нас важливо,
            щоб він читався на одному подиху, але цього не достатньо. Ми
            дивимося на те, які зерна сіє текст у дитячі серця, та чим ці зерна
            проростають. Наше завдання — створити НЕОБХІДНІ ДІТЯМ КНИЖКИ. Наше
            прагнення — зробити їх витворами мистецтва.
          </p>
        </div>
      </div>

      {selectedMaster && filteredProducts.length > 0 && (
        <div className={css.manuscriptNavigation}>
          <div>
            <p className={css.manuscriptNavigationLabel}>Рукописи майстра</p>
            <h2 className={css.manuscriptNavigationTitle}>
              {selectedMaster.name}
            </h2>
          </div>

          <div className={css.manuscriptNavigationActions}>
            <span className={css.manuscriptCounter}>
              {currentManuscriptIndex + 1} / {filteredProducts.length}
            </span>

            {filteredProducts.length > 1 && (
              <>
                <button
                  type="button"
                  className={css.manuscriptArrow}
                  onClick={handlePreviousManuscript}
                  aria-label="Попередній рукопис"
                  title="Попередній рукопис"
                >
                  <FiChevronLeft aria-hidden="true" />
                </button>
                <button
                  type="button"
                  className={css.manuscriptArrow}
                  onClick={handleNextManuscript}
                  aria-label="Наступний рукопис"
                  title="Наступний рукопис"
                >
                  <FiChevronRight aria-hidden="true" />
                </button>
              </>
            )}
          </div>
        </div>
      )}

      {currentProducts.length > 0 ? (
        currentProducts.map((manuscript) => (
          <ManuscriptProductComponent
            visitedProducts={visitedProducts}
            setVisitedProducts={setVisitedProducts}
            el={manuscript}
            key={getEntityId(manuscript)}
          />
        ))
      ) : (
        <div className={css.manuscriptNotFound}>
          {noMasterSearchResults
            ? "За цим запитом майстрів не знайдено."
            : selectedMaster
            ? "Для цього майстра рукописів за вибраним віком поки немає."
            : "Рукописів для вибраного віку поки немає."}
        </div>
      )}

      {!selectedMaster && numberOfPages > 1 && (
        <ListButtonCount
          pageNumbers={pageNumbers}
          handlePageClick={handlePageClick}
        />
      )}

      <ViewProductCatalog products={productsAll} />
      <Footer />
    </>
  );
}
